import {RequestAxios} from "../../index";
import {PersonnelOfZoneList} from "./interfaces";
import {API_START} from "../../constants";

export const getPersonnelOfZoneList = async (id: number) => {
    const PersonnelUrl = `${API_START}/client/store_zones/${id}/personnel`;
    return await RequestAxios.get<PersonnelOfZoneList[]>(PersonnelUrl)
}